import React from "react";

export default function TermsAndConditions() {
  return (
    <div className="container mx-auto px-6 py-12 text-gray-800">
      <nav className="text-sm text-gray-500 mb-4">
        Home » Terms and Conditions
      </nav>
      <h1 className="text-3xl font-bold text-primary mb-2">
        Terms and Conditions
      </h1>

      <div className="prose max-w-none">
        <p>
          These Terms of Service (the “Terms”) are a legal agreement between you
          (“you,” “your”) and Prepits Inc. (“we”, “us”, “Prepit”) with respect
          to Prepit’s Mobile App, its website prepitapp, and all associated
          services (collectively, the “Services”). These Terms apply to: (i)
          your use of the Services; and (ii) the use of the Services by third
          parties authorized by you through your Prepit account.
        </p>

        <p>
          By accessing, using or continuing to use the Services, you agree to be
          legally bound by the Terms and all terms, policies and guidelines
          incorporated by reference into the Terms. If you do not agree with the
          Terms in their entirety, you may not use the Services.
        </p>

        <h2>1. Privacy</h2>
        <p>
          You agree to Prepit’s Privacy Policy, which explains how we collect,
          use and protect the personal information you provide to us.
        </p>

        <h2>2. Account Registration</h2>
        <p>
          You must open an account with Prepit (a “Prepit Account”) to use the
          Services. During registration, we will ask you for information
          including your name and other personal information. You must provide
          accurate and complete information and keep it current.
        </p>

        <h2>3. Restrictions</h2>
        <p>
          You may not, nor may you permit any third party, directly or
          indirectly, to: (a) export the Services; (b) access or monitor any
          Prepit system using automation; (c) reverse engineer the Services; (d)
          interfere with or overload the Services; (e) reproduce, republish, or
          distribute material; (f) rent, lease, or transfer rights; (g) use for
          illegal activities; or (h) otherwise use the Services except as
          allowed under these Terms.
        </p>

        <h2>4. Compatible Hardware</h2>
        <p>
          We do not warrant that the Services will be compatible with your 
          mobile device or carrier. Your use of the Services may be subject to the
           terms of your agreements with your mobile device manufacturer or your carrier. 
           You may not use a modified device to use the Services if the modification is 
           contrary to the manufacturer’s software or hardware guidelines, including 
           disabling hardware or software controls.
        </p>
        <h2>5. Your Content</h2>
        <p>
          The Services may include functionality for uploading or providing photos, logos, 
          products, promotions, advertisements and other materials or information, including information 
          from your Customers (“Content”). You grant us and our subsidiaries, affiliates, 
          and successors a worldwide, non-exclusive, royalty-free, fully-paid, transferable, 
          and sub-licensable right to use, reproduce, modify, adapt, publish, prepare derivative works of, distribute, 
          publicly perform, and publicly display your Content throughout the world in any media in order to provide and promote the Services.
        </p>
        <p>
          You retain all rights in your Content, subject to the rights 
          you granted to us in these General Terms. You may modify or remove your Content via 
          your Prepit Account or by terminating your Prepit Account, but your Content may 
          persist in historical, archived or cached copies and versions thereof 
          available on or through the Services. You will not upload or provide 
          Content or otherwise post, transmit, distribute, or disseminate through the 
          Services any material that: (a) is false, misleading, unlawful, obscene, indecent, 
          lewd, pornographic, defamatory, libelous, threatening, harassing, hateful, abusive, 
          or inflammatory; (b) encourages conduct that would be considered a criminal offense or 
          gives rise to civil liability; (c) breaches any duty toward or rights of any person or entity, 
          including rights of publicity, privacy or trademark; (d) contains corrupted data or 
          any other harmful, disruptive, or destructive files;(e) advertises products or services 
          competitive with Prepit’s or its partners’ products and services, as determined by us in 
          our sole discretion; (f) in our sole judgment, is objectionable, restricts or inhibits 
          any person or entity from using or enjoying any portion of the Services, or which may 
          expose Prepit, its affiliates, its customers or its partners to harm or 
          liability of any nature; or (g) was obtained in breach of any applicable law,
           including personal privacy statutes, anti-spam legislation and consumer protection laws.
        </p>
        <p>
          Although we have no obligation to monitor any Content, we have absolute 
          discretion to remove Content at any time and for any reason without notice. 
          You understand that by using the Services, you may be exposed to Content that is offensive,
           indecent, or objectionable. We take no responsibility and assume no liability for 
           any Content, including any loss of or damage to any of your Content.
        </p>


        <h2>6. Intellectual Property</h2>
        <p>
          Prepit respects the copyright and trademark rights of others 
          and asks you to do the same. In the event your Content infringes 
          the copyrights, trademarks, or any intellectual property of others, 
          Prepit may suspend or terminate your access the Services.
        </p>

        <h2>7. Security</h2>
        <p>
          We have implemented technical and organizational measures 
          designed to secure your personal information from accidental 
          loss and from unauthorized access, use, alteration, or disclosure. 
          However, we cannot guarantee that unauthorized third parties will never 
          be able to defeat those measures or use your personal information for 
          improper purposes. You provide your personal information at your own risk.
        </p>
        <p>
          You are responsible for safeguarding your password and for restricting 
          access to the Services from your compatible mobile devices and computer(s). 
          You will immediately notify us of any unauthorized use of 
          your password or Prepit Account or any other breach of security.
        </p>

        <h2>8. Communications</h2>
        <p>
          You consent to accept and receive communications 
          from us, including e-mail, text messages, calls, and push notifications 
          to the cellular telephone number you provide to us. Standard message 
          and data rates applied by your cell phone carrier may apply to the text messages 
          we send you. You may opt-out of receiving communications by following the 
          unsubscribe options we provide to you in those communications. You acknowledge 
          that opting out of receiving communications may impact your use of the Services.
        </p>

        <h2>9. Fees and Taxes</h2>
        <p>
          You shall pay Prepit any fees specified in its Order Form, 
          in accordance with the timing and currency specified in the Order Form.
          Overdue amounts shall accrue interest at a rate which is the lesser of: two percent (2%) per month 
          or the maximum rate allowable by law. You are responsible for all taxes applicable 
          to the fees and charges in any applicable jurisdiction. Any Prepit fees will be
          deducted from your transaction proceeds, plus any applicable taxes. We reserve 
          the right to change our Fees upon thirty (30) days’ advance notice. Your continued 
          use of the Services after notice of a change to our Fees will constitute your agreement to such changes.
        </p>

        <h2>10. Termination</h2>
        <p>
          We may terminate these Terms or suspend or terminate your Prepit 
          Account or your access to any Service, at any time upon notice to you. 
          You may terminate these Terms by deactivating your Prepit Account at any time.
        </p>

        <h2>11. Effect of Termination</h2>
        <p>
          If these Terms or your Prepit Account is terminated or suspended 
          for any reason: (a) the license and any other rights granted under 
          these Terms will end, (b) we may (but have no obligation to) delete your 
          information and account data stored on our servers, and (c) we will not 
          be liable to you or any third party for compensation, reimbursement, or 
          damages for any termination or suspension of the Services, or for deletion 
          of your information or account data. In addition to any payment obligations 
          under these Terms, the following sections of these General Terms survive and 
          remain in effect in accordance with their terms upon termination: 5 (Your Content), 
          6 (Intellectual Property), 11 (Effect of Termination), 13 (Ownership), 14 (Indemnity), 
          15 (Representations and Warranties), 16 (No Warranties), 17 (Limitation of Liability), 
          18 (Third Party Products), 19 (Governing Law), 20 (Assignment), and 22 (Miscellaneous).
        </p>

        <h2>12. Your License</h2>
        <p>
          We grant you a limited, non-exclusive, revocable, non-transferable, 
          non-sublicensable license to use the software that is part of the Services, 
          as authorized in these Terms. We may make software updates to the Services 
          available to you, which you must install to continue using the Services. 
          Any such software updates may be subject to additional terms made known to you at that time.
        </p>

        <h2>13. Ownership</h2>
        <p>
          We reserve all rights not expressly granted to you in these Terms. 
          We own all rights, title, interest, copyright and other worldwide Intellectual 
          Property Rights (as defined below) in the Services and all copies of the Services. 
          These Terms do not grant you any rights to our trademarks or service marks. 
          For the purposes of these Terms, “Intellectual Property Rights” means all patent rights, 
          copyright rights, mask work rights, moral rights, rights of publicity, trademark, 
          trade dress and service mark rights, goodwill, trade secret rights, and other 
          intellectual property rights that may exist now or come into existence in the 
          future, and all of their applications, registrations, renewals and extensions, 
          under the laws of any province, country, territory or other jurisdiction. 
          You may submit comments or ideas about the Services (“Feedback”). By submitting any Feedback, 
          you agree that your disclosure is gratuitous, unsolicited, and without restriction, 
          that it will not place us under any fiduciary, confidentiality or other obligation, 
          and that we are free to use the Feedback without any additional compensation to you, 
          and/or to disclose the Feedback on a non-confidential basis or otherwise to anyone.
        </p>

        <h2>14. Indemnity</h2>
        <p>
          You will indemnify, defend, and hold us and our respective 
          employees, directors, agents, affiliates, and representatives 
          harmless from and against any and all claims, costs, losses, damages, 
          judgments, tax assessments, penalties, interest, and 
          expenses (including reasonable legal’ fees) arising out of any 
          claim, action, audit, investigation, inquiry, or other proceeding 
          instituted by a person or entity that arises out of or relates to: (a) any actual 
          or alleged breach of your representations, warranties, or obligations set forth in these 
          Terms; (b) your wrongful or improper use of the Services; (c) your violation 
          of any third-party right, including any right of privacy, publicity rights or 
          Intellectual Property Rights; (d) your violation of any law, rule or regulation of 
          Canada (including its provinces and territories) or any other country; and (e) any other 
          party’s access and/or use of the Services with your unique name, password or other appropriate security code.
        </p>

        <h2>15. Representations and Warranties</h2>
        <p>
          You represent and warrant to us that: (a) you are at least 
          eighteen (18) years of age; (b) you are eligible to register 
          and use the Services and have the right, power, and ability to 
          enter into and perform under these Terms; (c) any information you 
          provide accurately and truthfully represents your business or personal 
          identity under which you sell goods and services; (d) you and all 
          transactions initiated by you will comply with all federal, provincial, 
          territorial, and local laws, rules, and regulations applicable to you 
          and/or your business, including all laws governing the protection of 
          personal information, anti-spam legislation and consumer protection laws; (e) 
          you will not use the Services, directly or indirectly, for any fraudulent 
          undertaking or in any manner so as to interfere with the operation of the 
          Services; and (f) your use of the Services will be in compliance with these Terms.
        </p>

        <h2>16. No Warranties</h2>
        <p>
          THE SERVICES ARE PROVIDED “AS IS” WITHOUT REPRESENTATION OR 
          WARRANTY, WHETHER EXPRESS, IMPLIED, OR STATUTORY. WITHOUT LIMITING 
          THE FOREGOING, PREPIT SPECIFICALLY DISCLAIMS ANY IMPLIED WARRANTIES 
          OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NON-INFRINGEMENT. 
          PREPIT DOES NOT WARRANT OR GUARANTEE THAT THE SERVICES ARE ACCURATE, 
          RELIABLE OR CORRECT; THAT THE SERVICES WILL MEET YOUR REQUIREMENTS; 
          THAT THE SERVICES WILL BE AVAILABLE AT ANY PARTICULAR TIME OR LOCATION, 
          UNINTERRUPTED, ERROR-FREE, WITHOUT DEFECT OR SECURE; THAT ANY DEFECTS OR 
          ERRORS WILL BE CORRECTED; OR THAT THE SERVICES ARE FREE OF VIRUSES OR OTHER 
          HARMFUL COMPONENTS. Prepit does not warrant, endorse, guarantee, or assume 
          responsibility for any product or services advertised or offered by a third party. 
          Prepit does not have control of, or liability for, goods or services that are paid for using the Services.
        </p>

        <h2>17. Limitations of Liability</h2>
        <p>
          TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, IN NO EVENT WILL 
          PREPIT BE LIABLE FOR ANY DIRECT, INDIRECT, PUNITIVE, INCIDENTAL, SPECIAL, 
          CONSEQUENTIAL, OR EXEMPLARY DAMAGES, INCLUDING WITHOUT LIMITATION DAMAGES FOR 
          LOSS OF PROFITS, GOODWILL, USE, DATA, OR OTHER INTANGIBLE LOSSES, THAT RESULT 
          FROM THE USE OF, INABILITY TO USE, OR UNAVAILABILITY OF THE SERVICES. IN ALL CASES, 
          PREPIT WILL NOT BE LIABLE FOR ANY LOSS OR DAMAGE THAT IS NOT REASONABLY FORESEEABLE. 
          UNDER NO CIRCUMSTANCES WILL PREPIT BE RESPONSIBLE FOR ANY DAMAGE, LOSS, 
          OR INJURY RESULTING FROM HACKING, TAMPERING, OR OTHER UNAUTHORIZED ACCESS OR 
          USE OF THE SERVICES OR YOUR PREPIT ACCOUNT, OR THE INFORMATION CONTAINED THEREIN. 
          TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, THE TOTAL LIABILITY OF PREPIT IS 
          LIMITED TO THE GREATER OF (A) THE AMOUNT OF FEES EARNED BY US IN CONNECTION WITH YOUR 
          USE OF THE SERVICES DURING THE THREE (3) MONTH PERIOD IMMEDIATELY PRECEDING THE EVENT 
          GIVING RISE TO THE CLAIM FOR LIABILITY, OR (B) $100.
          <p>
            Prepit makes no representations that the Services are appropriate 
            or available for use other than in Canada. Those who access or use the 
            Services from other jurisdictions do so at their own volition and are entirely 
            responsible for compliance with all applicable Canadian and local laws and regulations, 
            including but not limited to export and import regulations.Prepit makes no 
            representations that the Services are appropriate or available for use other than 
            in Canada. Those who access or use the Services from other jurisdictions do so at 
            their own volition and are entirely responsible for compliance with all applicable 
            Canadian and local laws and regulations, including but not limited to export and import regulations.
          </p>
        </p>

        <h2>18. Third Party Products</h2>
        <p>
          All third party hardware and other products used with the Services 
          are not the responsibility of Prepit and should be used solely according 
          to the warranty and other terms specified by the manufacturer, who is solely 
          responsible for service and support for its product. For service, support, or 
          warranty assistance, you should contact the manufacturer directly. PREPIT MAKES 
          NO REPRESENTATIONS OR WARRANTIES, EXPRESS OR IMPLIED, WITH RESPECT TO SUCH THIRD 
          PARTY PRODUCTS, AND EXPRESSLY DISCLAIMS ANY WARRANTY OR CONDITION OF MERCHANTABILITY, 
          NON-INFRINGEMENT, OR FITNESS FOR A PARTICULAR PURPOSE.
        </p>

        <h2>19. Governing Law</h2>
        <p>These Terms and any related dispute will be governed by Ontario law and/or 
          applicable Canadian federal law, without regard to choice of law or conflicts of law principles.
        </p>

        <h2>20. Assignment</h2>
        <p>
          These Terms and any rights and licenses granted hereunder or thereunder 
          may not be transferred or assigned by you and any attempted transfer or 
          assignment will be null and void.
        </p>

        <h2>21. Third Party Services</h2>
        <p>
          You may be offered services, products and promotions provided by 
          third parties and not by Prepit (“Third Party Services”). If you 
          decide to use Third Party Services you will be responsible for reviewing and 
          understanding the terms and conditions for these services. We are not responsible 
          for the performance of any Third Party Services. The Services may contain links to 
          third party websites. The inclusion of any website link does not imply an approval, 
          endorsement, or recommendation by Prepit. Such third party websites are not governed 
          by these Terms. You access any such website at your own risk. We expressly disclaim any 
          liability for these websites. When you use a link to go from the Services to a third party 
          website, our Privacy Policy is no longer in effect. Your browsing and interaction on a 
          third party website, including those that have a link in the Services, are subject to 
          that website’s own terms, rules and policies.
        </p>

        <h2>22. Miscellaneous</h2>
        <p>
          These Terms, and any other applicable policies, are a complete 
          statement of the agreement between you and Prepit regarding the Services. 
          In the event of a conflict between these Terms and any other Prepit agreement 
          or policy, these Terms will prevail and control the subject matter of such conflict. 
          If any provision of these Terms is invalid or unenforceable under applicable law, 
          then it will be changed and interpreted to accomplish the objectives of such provision 
          to the greatest extent possible under applicable law, and the remaining provisions will 
          continue in full force and effect. These Terms do not limit any rights that we may have 
          under trade secret, copyright, patent, or other laws. No waiver of any term of these Terms 
          will be deemed a further or continuing waiver of such term or any other term.
        </p>

        <h2>23. Contact Information</h2>
        <p>
          Please contact Prepit Support at: info@prepitapp.com

          for all customer support and account related inquiries.
          <a href="mailto:info@prepitapp.com">info@prepitapp.com</a> for all
          customer support and account related inquiries.
        </p>
      </div>
    </div>
  );
}
